module.exports = __webpack_public_path__ + "img/bg-threat-medium.368c970e.png";